export default __webpack_public_path__ + "static/media/234.6a2cb791.png";